import { React, useState, useEffect } from "react";

import { useLocation, useParams } from "react-router-dom";

import {
  getClass,
  getStudents,
  getQR,
  getSenStudents,
} from "../services/APIClient";

import HeadingBanner from "../components/HeadingBanner";
import LeftPanel from "../components/LeftPanel";
import SENWatchlistOverview from "../components/SENWatchlistOverview";
import OrientationPrompt from "../components/OrientationPrompt";

import { Container, Row, Col, Card } from "react-bootstrap";

import "../components/ClassOverview.css";

function SENWatchlist(props) {
  const location = useLocation();

  let classDetails = location.state?.classDetails?.classDetails;
  let teachers = location.state?.teachers?.teachers;
  let assessment = location.state?.assessment?.assessment;

  let schoolid = location.state?.schoolid?.schoolid;
  let teacherid = location.state?.teacherid?.teacherid;

  let studentsReadingScore =
    location.state?.studentsReadingScore?.studentsReadingScore;

  let readingScores = location.state.readingScores.readingScores;

  const YEAR_RANGES = {
    "24/25": { start: "2024-08-01", end: "2025-07-31" },
    // "23/24": { start: "2023-08-01", end: "2024-07-31" },
    // "22/23": { start: "2022-08-01", end: "2023-07-31" },
  };

  const [selectedYear, setSelectedYear] = useState(null);
  const [selectedGradeLevel, setSelectedGradeLevel] = useState(null); // New state for grade level filter
  const [group, setGroup] = useState("");
  const [isPortrait, setIsPortrait] = useState(
    window.matchMedia("(orientation: portrait)").matches
  );
  const [students, setStudents] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  console.log(students, "students");

  const fetchSenStudents = async () => {
    try {
      setLoading(true);
      const data = await getSenStudents(schoolid);
      // Ensure dateCreated is available for all students
      const studentsWithDateCreated = data.map((student) => ({
        ...student,
        dateCreated: student.dateCreated || new Date().toISOString(), // Fallback if missing
      }));
      setStudents(studentsWithDateCreated);
    } catch (err) {
      console.error("Failed to fetch students:", err);
      setError(err.message || "An error occurred");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (schoolid) {
      fetchSenStudents();
    }
  }, [schoolid]);

  useEffect(() => {
    const handleOrientationChange = () => {
      setIsPortrait(window.innerWidth < window.innerHeight);
    };

    window.addEventListener("resize", handleOrientationChange);

    return () => {
      window.removeEventListener("resize", handleOrientationChange);
    };
  }, []);

  // useEffect(() => {
  //   window.HubSpotConversations?.widget?.refresh();
  // }, []);

  let sharedWith = group.sharedWith;

  // useEffect(() => {
  //   window.HubSpotConversations?.widget?.refresh();
  // }, []);

  // Filter students based on selected year and grade level
  const filteredStudents = students.filter((student) => {
    if (!selectedYear || !YEAR_RANGES[selectedYear]) return false;

    const { start, end } = YEAR_RANGES[selectedYear];
    const dateCreated = new Date(student.dateCreated);
    const isWithinYearRange =
      dateCreated >= new Date(start) && dateCreated <= new Date(end);

    if (!selectedGradeLevel) return isWithinYearRange;

    return (
      isWithinYearRange &&
      ((selectedGradeLevel === "grade_level1" && student.grade_level1) ||
        (selectedGradeLevel === "grade_level2" && student.grade_level2))
    );
  });

  return (
    <Container fluid className="vh-100">
      <HeadingBanner
        name={""}
        isLoggedIn={true}
        cloud={true}
        teacherid={teacherid}
      />
      <Row className="h-100">
        <LeftPanel />
        <Col sm={{ span: 10, offset: 2 }} className="blue-background">
          {!selectedYear ? (
            <Card className="dynamic-box">
              <div className="school-info-header mb-3">
                <h4 className="mb-1">SEN Watchlist</h4>
              </div>
              <h5 className="step-indicator">Step 1: Select Academic Year</h5>
              <Row className="justify-content-center mb-3">
                {Object.keys(YEAR_RANGES).map((year) => (
                  <Col md={4} key={year} className="mb-3">
                    <button
                      className={`year-selection-button w-100 py-3 shadow-sm rounded ${
                        selectedYear === year ? "selected" : ""
                      }`}
                      onClick={() => setSelectedYear(year)}
                    >
                      <h3>{year}</h3>
                      <small className="text-muted d-block mt-2">
                        {new Date(YEAR_RANGES[year].start).toLocaleDateString(
                          "en-IE",
                          { month: "short", year: "numeric" }
                        )}{" "}
                        -
                        {new Date(YEAR_RANGES[year].end).toLocaleDateString(
                          "en-IE",
                          { month: "short", year: "numeric" }
                        )}
                      </small>
                    </button>
                  </Col>
                ))}
              </Row>
            </Card>
          ) : !selectedGradeLevel ? (
            <Card className="dynamic-box">
              <div className="school-info-header mb-3">
                <h4 className="mb-1">SEN Watchlist</h4>
              </div>
              <h5 className="step-indicator">Step 2: Select Grade Level</h5>
              <Row className="justify-content-center mb-3">
                {["grade_level1", "grade_level2"].map((level) => (
                  <Col md={4} key={level} className="mb-3">
                    <button
                      className={`year-selection-button w-100 py-3 shadow-sm rounded ${
                        selectedGradeLevel === level ? "selected" : ""
                      }`}
                      onClick={() => setSelectedGradeLevel(level)}
                    >
                      <h3>
                        {level === "grade_level1"
                          ? "Junior Infants"
                          : "Senior Infants"}
                      </h3>
                    </button>
                  </Col>
                ))}
              </Row>
            </Card>
          ) : (
            <SENWatchlistOverview
              assessment={assessment}
              classDetails={classDetails}
              teachers={teachers}
              sharedWith={sharedWith}
              students={filteredStudents} // Pass filtered students
              teacherid={teacherid}
              studentsReadingScore={studentsReadingScore}
              schoolid={schoolid}
              readingScores={readingScores}
              selectedYear={selectedYear}
              yearRange={YEAR_RANGES[selectedYear]}
            />
          )}
        </Col>
      </Row>
      {isPortrait && <OrientationPrompt />}
    </Container>
  );
}

export default SENWatchlist;
